import { Component, inject, OnInit } from '@angular/core';
import { SplashScreenService } from '../../../../shared/services/splash-screen/splash-screen.service';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import { filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-login-callback',
  standalone: true,
  imports: [],
  templateUrl: './login-callback.component.html',
  styleUrl: './login-callback.component.scss',
})
export class LogInCallbackComponent extends DestroyBase implements OnInit {
  splashScreenService = inject(SplashScreenService);
  authService = inject(AuthService);
  router = inject(Router);
  route = inject(ActivatedRoute);

  ngOnInit(): void {
    const queryError =
      this.route.snapshot.queryParamMap.get('error') ||
      new URLSearchParams(window.location.search).get('error');

    if (queryError) {
      this.splashScreenService.hide();
      this.router.navigate(['/login'], {
        queryParams: { error: queryError },
      });
      return;
    }

    this.authService.auth0.error$
      .pipe(
        filter((err): err is Error => !!err),
        takeUntil(this.destroy$),
      )
      .subscribe((err) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errAny = err as any;
        const errorVal = errAny?.error || err?.message || 'login_failed';
        this.splashScreenService.hide();
        this.router.navigate(['/login'], {
          queryParams: { error: errorVal },
        });
      });

    this.splashScreenService.show('Authenticating...');

    setTimeout(() => {
      this.splashScreenService.updateMessage('Loading user preferences…');
    }, 1200);

    setTimeout(() => {
      this.splashScreenService.updateMessage('Fetching dashboard data…');
    }, 2400);

    setTimeout(() => {
      this.splashScreenService.updateMessage('Setting things up…');
    }, 3600);

    setTimeout(() => {
      this.splashScreenService.updateMessage('Finalizing your experience…');
    }, 4800);
  }
}
